import { useEffect } from "react";

const NavigationHeading = ({ path, setHeadingTitle }) => {
  useEffect(() => {

    if (path === "/user-listing") {
      setHeadingTitle("User Management");
    } else if (path === "/project-listing") {
      setHeadingTitle("Project Management");
    } else if (path === "/add-project") {
      setHeadingTitle("Project Management");
    } else if (path.startsWith("/view-project/")) {
      setHeadingTitle("Project Management");
    } else if (path.startsWith("/update-project/")) {
      setHeadingTitle("Project Management");
    } else if (path === "/create-user") {
      setHeadingTitle("User Management");
    } else if (path.startsWith("/view-user/")) {
      setHeadingTitle("User Management");
    } else if (path.startsWith("/update-user/")) {
      setHeadingTitle("User Management");
    } else if (path === "/datalibrary-listing") {
      setHeadingTitle("Data Library");
    } else if (path.startsWith("/add-datalibrary")) {
      setHeadingTitle("Data Library");
    } else if (path.startsWith("/update-datalibrary")) {
      setHeadingTitle("Data Library");
    } else if (path === "/inspection-listing") {
      setHeadingTitle("Inspection");
    } else if (path.startsWith("/view-inspection")) {
      setHeadingTitle("Inspection");
    } else if (path.startsWith("/add-inspection")) {
      setHeadingTitle("Inspection");
    } else if (path.startsWith("/update-inspection")) {
      setHeadingTitle("Inspection");
    } else if (path === "/template-listing") {
      setHeadingTitle("Template");
    } else if (path === "/add-template") {
      setHeadingTitle("Template");
    } else if (path.startsWith("/update-template")) {
      setHeadingTitle("Template");
    } else if (path.startsWith("/view-template")) {
      setHeadingTitle("Template");
    } else if (path.startsWith("/template-logs")) {
      setHeadingTitle("Template Logs");
    } else if (path.startsWith("/view-template-logs")) {
      setHeadingTitle("Template Logs");
    } else if (path === "/audit-logs" || path.startsWith("/view-audit-logs")) {
      setHeadingTitle("Audit Logs");
    } else if (path.startsWith("/start-inspection")) {
      setHeadingTitle("Start Inspection");
    } else if (path.startsWith("/user-profile")) {
      setHeadingTitle("Profile");
    } else if (path.startsWith("/edit-user-profile")) {
      setHeadingTitle("Edit Profile");
    } else if (path.startsWith("/settings")) {
      setHeadingTitle("Settings");
    } else if (path.startsWith("/dashboard")) {
      setHeadingTitle("Dashboard")
    }
    else {
      setHeadingTitle("Invalid"); // Default title
    }
  }, [path, setHeadingTitle]); // Only run when path changes

  return null; // No need to return anything
};

export default NavigationHeading;
